import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api'

@Injectable({
  providedIn: 'root'
})
export class CustomMessageService {

  constructor(private messageService: MessageService) { }

  displayMessage(message: string, type: string): any {
    let messages = message.split('\n');
    if (messages.length == 1)
      return {
        closable: true,
        sticky: false,
        details : messages[0],
        life: 2000,
        severity: type,
        
      };
    let messageModel = [];
    for (let i = 0; i < messages.length; i++) {
      messageModel.push({
        closable: true,
        sticky: false,
        data: messages[i],
        life: 2000,
        severity: type,
      });
    }
    return messageModel;

  }
}
